import React from "react";
import { t } from "i18next";
import { LineChartOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import {
  Row,
  Col,
  Breadcrumb,
  Card,
  Button,
  Result
} from "common/elements";
import { Util } from "common/util";

export default function Index() {
  let navigate = useNavigate();

  const onView = (link) => {
    navigate(link);
  };

  if (!Util.getInstance().hasPermission("view", "payroll report")) {
    return <Result
      status="403"
      title="403"
      subTitle={t("text_sorry_you_are_not_authorized_to_access_this_page")}
    />;
  }

  return (
    <>
      <Row style={styles.breadCream}>
        <Col span={24}>
          <Breadcrumb>
            <Breadcrumb.Item
              onClick={() => navigate("/")}
              style={{ cursor: "pointer" }}
            >
              {t("text_dashboard")}
            </Breadcrumb.Item>
            <Breadcrumb.Item style={{ color: "#1d8747" }}>
              {t("text_payroll_report")}
            </Breadcrumb.Item>
          </Breadcrumb>
        </Col>
      </Row>
      <div style={{ height: "86vh", overflowY: "auto" }}>
        <Row
          gutter={[32, 32]}
          style={{ margin: 15 }}
          id="attendance-report"
        // align="middle"
        >
          {
            Util.getInstance().hasPermission("payroll for bank", "payroll report") &&
            <Col sm={24} md={24} lg={12} xl={12} xxl={8}>
              <Card
                className="report-attendance-card"
                title={
                  <div className="title-attendance-report">
                    <LineChartOutlined id="report-line-chart-icon" />
                    <span>Payroll For Bank</span>
                  </div>
                }
                actions={[
                  <div className="action-button-view">
                    <Button
                      className="btn-view-attendance"
                      onClick={() => onView("/reports/payroll/payroll_for_bank")}
                    >
                      <span>{t("text_view")}</span>
                    </Button>
                  </div>
                ]}
              >
              </Card>
            </Col>
          }

          {
            Util.getInstance().hasPermission("nssf report", "payroll report") &&
            <Col sm={24} md={24} lg={12} xl={12} xxl={8}>
              <Card
                className="report-attendance-card"
                title={
                  <div className="title-attendance-report">
                    <LineChartOutlined id="report-line-chart-icon" />
                    <span>NSSF Report</span>
                  </div>
                }
                actions={[
                  <div className="action-button-view">
                    <Button
                      className="btn-view-attendance"
                      onClick={() => onView("/reports/payroll/payroll_for_nssf")}
                    >
                      <span>{t("text_view")}</span>
                    </Button>
                  </div>,
                ]}
              >
              </Card>
            </Col>
          }

          {
            Util.getInstance().hasPermission("payroll for e-filling", "payroll report") &&
            <Col sm={24} md={24} lg={12} xl={12} xxl={8}>
              <Card
                className="report-attendance-card"
                title={
                  <div className="title-attendance-report">
                    <LineChartOutlined id="report-line-chart-icon" />
                    <span>Payroll For E-Filling</span>
                  </div>
                }
                actions={[
                  <div className="action-button-view">
                    <Button
                      className="btn-view-attendance"
                      onClick={() =>
                        onView("/reports/payroll/payroll_for_tax")
                      }
                    >
                      <span>{t("text_view")}</span>
                    </Button>
                  </div>,
                ]}
              >
              </Card>
            </Col>
          }
          {
            Util.getInstance().hasPermission("payroll report", "payroll report") &&
            <Col sm={24} md={24} lg={12} xl={12} xxl={8}>
              <Card
                className="report-attendance-card"
                title={
                  <div className="title-attendance-report">
                    <LineChartOutlined id="report-line-chart-icon" />
                    <span>Payrolls</span>
                  </div>
                }
                actions={[
                  <div className="action-button-view">
                    <Button
                      className="btn-view-attendance"
                      onClick={() =>
                        onView("/reports/payroll/payrolls")
                      }
                    >
                      <span>{t("text_view")}</span>
                    </Button>
                  </div>,
                ]}
              >
              </Card>
            </Col>
          }

          {
            Util.getInstance().hasPermission("cost sharing", "payroll report") &&
            <Col sm={24} md={24} lg={12} xl={12} xxl={8}>
              <Card
                className="report-attendance-card"
                title={
                  <div className="title-attendance-report">
                    <LineChartOutlined id="report-line-chart-icon" />
                    <span>Cost Shared</span>
                  </div>
                }
                actions={[
                  <div className="action-button-view">
                    <Button
                      className="btn-view-attendance"
                      onClick={() =>
                        onView("/reports/payroll/cost_sharing")
                      }
                    >
                      <span>{t("text_view")}</span>
                    </Button>
                  </div>,
                ]}
              >
              </Card>
            </Col>
          }

          {
            Util.getInstance().hasPermission("provident fund", "payroll report") &&
            <Col sm={24} md={24} lg={12} xl={12} xxl={8}>
              <Card
                className="report-attendance-card"
                title={
                  <div className="title-attendance-report">
                    <LineChartOutlined id="report-line-chart-icon" />
                    <span>Monthly Allocation Provident Fund</span>
                  </div>
                }
                actions={[
                  <div className="action-button-view">
                    <Button
                      className="btn-view-attendance"
                      onClick={() =>
                        onView("/reports/payroll/monthly_allocation_provident_fund")
                      }
                    >
                      <span>{t("text_view")}</span>
                    </Button>
                  </div>,
                ]}
              >
              </Card>
            </Col>
          }

          {
            Util.getInstance().hasPermission("13th month salary", "payroll report") &&
            <Col sm={24} md={24} lg={12} xl={12} xxl={8}>
              <Card
                className="report-attendance-card"
                title={
                  <div className="title-attendance-report">
                    <LineChartOutlined id="report-line-chart-icon" />
                    <span>Monthly Allocation of 13th Month Salary</span>
                  </div>
                }
                actions={[
                  <div className="action-button-view">
                    <Button
                      className="btn-view-attendance"
                      onClick={() =>
                        onView("/reports/payroll/monthly_allocation_of_13th_month_salary")
                      }
                    >
                      <span>{t("text_view")}</span>
                    </Button>
                  </div>,
                ]}
              >
              </Card>
            </Col>
          }

          {
            Util.getInstance().hasPermission("seniority and severance pay", "payroll report") &&
            <Col sm={24} md={24} lg={12} xl={12} xxl={8}>
              <Card
                className="report-attendance-card"
                title={
                  <div className="title-attendance-report">
                    <LineChartOutlined id="report-line-chart-icon" />
                    <span>Monthly Allocation Seniority And Severance Pay</span>
                  </div>
                }
                actions={[
                  <div className="action-button-view">
                    <Button
                      className="btn-view-attendance"
                      onClick={() =>
                        onView("/reports/payroll/monthly_allocation_seniority_and_severance_pay")
                      }
                    >
                      <span>{t("text_view")}</span>
                    </Button>
                  </div>,
                ]}
              >
              </Card>
            </Col>
          }

             {
            Util.getInstance().hasPermission("seniority and severance pay", "payroll report") &&
            <Col sm={24} md={24} lg={12} xl={12} xxl={8}>
              <Card
                className="report-attendance-card"
                title={
                  <div className="title-attendance-report">
                    <LineChartOutlined id="report-line-chart-icon" />
                    <span>Total Wages & Benefits Per Semester</span>
                  </div>
                }
                actions={[
                  <div className="action-button-view">
                    <Button
                      className="btn-view-attendance"
                      onClick={() =>
                        onView("/reports/payroll/seniority_payment")
                      }
                    >
                      <span>{t("text_view")}</span>
                    </Button>
                  </div>,
                ]}
              >
              </Card>
            </Col>
          }
        </Row>
      </div>
    </>
  );
}

const styles = {
  generalSearch: {
    width: 200,
  },
  headerFilter: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  breadCream: {
    paddingBottom: 15,
    backgroundColor: "#EFF3F6",
  },
};

